import React from "react";
import { useTranslation } from "@me8eon/translation";

// Shown when the dashboard data fails to load. We deliberately show this instead of any
// placeholder numbers — a product owner must never see invented/mock figures on a live page.
const TabError: React.FC<{ message?: string }> = ({ message }) => {
    const t = useTranslation();
    return (
        <div className="po-error" role="alert">
            <span className="po-error__icon" aria-hidden="true">⚠️</span>
            <div>
                <div className="po-error__title">{t("productDashboard.tabError.title")}</div>
                <div className="po-error__sub">
                    {message ?? t("productDashboard.tabError.message")}
                </div>
            </div>
        </div>
    );
};

export default TabError;
